export default {
  BLUE_NCS: '#2589BD',
  YELLOW_CRAYOLA: '#FBB13C',
  SHAMROCK_GREEN: '#499F68',
  BRIGHT_MAROON: '#B9344D',
  ALTO: '#DBDBDB',
  INDEPENDENCE: '#43425D'
};
